import { getLogger } from '@lib/util/logging-util';

const logger = getLogger();

export const handleError = (error: Error) => {
  if (process.env.NODE_ENV === "development") {
    logger.error(error)
  }
}
